module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer012"
    }
  }, [_c('h1', {
    staticClass: "Prelim-head",
    attrs: {
      "id": "_idParaDest-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  }), _vm._v("About the Author")]), _vm._v(" "), _c('p', {
    staticClass: "Prelim-text"
  }, [_vm._v("Rita is married with adult sons and grandchildren. As well as writing for children, she is an avid reader. Her interests include nature, gardening, crafts and walking her dog. She worked in two schools for around 25 years as a dinner lady. Out of hours, she is a club worker, classroom assistant, special needs teaching assistant and breakfast club leader.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59b73ee1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781528954297_EPUB.vue
// module id = 57
// module chunks = 0